import { useEffect } from "react";

export default function ConfirmModal({
  title,
  description,
  items = [],
  confirmLabel,
  confirmTone = "primary",
  isSubmitting = false,
  error = "",
  onConfirm,
  onCancel,
}) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && !isSubmitting) onCancel();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isSubmitting, onCancel]);

  return (
    <div
      className="admin-modal-backdrop admin-confirm-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget && !isSubmitting) onCancel();
      }}
    >
      <section className="admin-modal admin-confirm-modal" role="dialog" aria-modal="true" aria-labelledby="confirm-modal-title">
        <div className="admin-modal-header">
          <div>
            <p className="admin-page-eyebrow">Please confirm</p>
            <h2 id="confirm-modal-title">{title}</h2>
            <p>{description}</p>
          </div>
        </div>
        <div className="admin-modal-body">
          {items.length > 0 && (
            <ul className="admin-confirm-list">
              {items.map((item) => <li key={item}>{item}</li>)}
            </ul>
          )}
          {error && <p className="admin-form-error" role="alert">{error}</p>}
        </div>
        <div className="admin-modal-footer">
          <button className="admin-button admin-button-secondary" type="button" onClick={onCancel} disabled={isSubmitting}>
            Go Back
          </button>
          <button
            className={`admin-button admin-button-${confirmTone}`}
            type="button"
            onClick={onConfirm}
            disabled={isSubmitting}
            autoFocus
          >
            {isSubmitting ? "Working..." : confirmLabel}
          </button>
        </div>
      </section>
    </div>
  );
}
